import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { VerifyIdentityRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { VerifyIdentityResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const verifyIdentity = (request: VerifyIdentityRequest, options?: CashRequestOptions) =>
  post<VerifyIdentityRequest, VerifyIdentityResponse>('/2.0/cash/verify-identity', request, {
    ...options,
    rejectOnError: true,
  })
